import { render } from "./Overlay3D.vue?vue&type=template&id=01c8e5bf&scoped=true"
import script from "./Overlay3D.vue?vue&type=script&lang=js"
export * from "./Overlay3D.vue?vue&type=script&lang=js"

import "./Overlay3D.vue?vue&type=style&index=0&id=01c8e5bf&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c8e5bf"]])

export default __exports__